export default class PlatformTypes {
  static IOS = "ios";

  static ANDROID = "android";
}
